import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "cnk" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = { class: "vat" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = { class: "d-flex justify-content-end align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_edit_button = _resolveComponent("base-edit-button")!
  const _component_base_delete_button = _resolveComponent("base-delete-button")!

  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, [
      (_ctx.product.main_image_url)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.product.main_image_url,
            alt: "image",
            style: {"width":"50px","height":"50px"}
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.product.product.name), 1),
    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.product.product.cnk_code), 1),
    _createElementVNode("td", _hoisted_5, _toDisplayString('€ ' + _ctx.product.product.price_with_vat), 1),
    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.product.product.vat_percentage + '%'), 1),
    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.product.product.status.description ? _ctx.product.product.status.description : '/'), 1),
    _createElementVNode("td", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_base_edit_button, {
          targetRoute: {name: 'edit-customer-product', params: {id: _ctx.product.product.product_code}}
        }, null, 8, ["targetRoute"]),
        _createVNode(_component_base_delete_button, {
          deleteData: () => _ctx.deleteProduct(_ctx.product.product.product_code),
          pageUI: _ctx.pageUI,
          class: "ms-2",
          itemKey: _ctx.product.product.product_code
        }, null, 8, ["deleteData", "pageUI", "itemKey"])
      ])
    ])
  ]))
}